import type { DataMeshTrackingClient } from "../tracking/DataMeshTrackingProvider";
import type { EventHandlers } from "./types";

export const createEventHandlers = <T extends HTMLElement = HTMLDivElement>({
  trackClick,
  trackComponentDisplayed,
}: DataMeshTrackingClient) => {
  const eventHandlers: EventHandlers<T> = {
    click: ({ element, trackingObj }) => {
      const handleTrackClickFunction = () => trackClick(trackingObj);

      return {
        effect: () => {
          element.addEventListener("click", handleTrackClickFunction);
        },
        cleanup: () => {
          element.removeEventListener("click", handleTrackClickFunction);
        },
      };
    },
    display: ({ trackingObj }) => {
      return {
        effect: () => trackComponentDisplayed(trackingObj),
        cleanup: () => {},
      };
    },
  } as const;
  return eventHandlers;
};
